import { type Icon, IconSVG, SVGColorKey } from "@studio3t/generic-components";
import type { ReactNode } from "react";
import styled from "styled-components";

const Container = styled.div`
  text-align: center;
  padding: 64px;
  background: ${(props) => props.theme.cards1Background};
  border: 1px solid ${(props) => props.theme.cards1Border};
  border-radius: 6px;
`;

const IconWrapper = styled.div`
  margin-bottom: 16px;
`;

const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${(props) => props.theme.semanticTextHeading};
  margin: 0 0 8px 0;
`;

const Description = styled.p`
  font-size: 13px;
  color: ${(props) => props.theme.semanticTextLight};
  margin: 0;
`;

export interface EmptyStateProps {
  icon?: Icon;
  title: string;
  description?: ReactNode;
}

export function EmptyState({ icon, title, description }: EmptyStateProps) {
  return (
    <Container>
      {icon && (
        <IconWrapper>
          <IconSVG
            icon={icon}
            size={32}
            svgColorKey={SVGColorKey.semanticTextPlaceholder}
          />
        </IconWrapper>
      )}
      <Title>{title}</Title>
      {description && <Description>{description}</Description>}
    </Container>
  );
}
